(() => {
  const findFooter = () =>
    document.querySelector('footer.elizna-footer') ||
    document.querySelector('.elizna-footer') ||
    document.querySelector('footer.footer') ||
    document.querySelector('footer');

  const normalize = (s) => (s || '').replace(/\s+/g, ' ').trim();

  const relabel = (footer) => {
    const links = [...footer.querySelectorAll('a')];

    const map = new Map([
      ['Home', 'ELIZNA™ Home'],
      ['Catalog', 'Shop ELIZNA™'],
      ['Contact', 'ELIZNA™ Client Care'],
      ['Privacy', 'Privacy & Data']
    ]);

    for (const a of links) {
      const current = normalize(a.textContent);
      if (map.has(current)) {
        a.textContent = map.get(current);
      }
    }
  };

  const addAppLink = (footer) => {
    if (footer.querySelector('a[href="/pages/elizna-app"]')) return;

    // Prefer placing the new link inside the same menu/list that contains Home / Catalog.
    const exploreLink = [...footer.querySelectorAll('a')].find((a) => {
      const t = normalize(a.textContent);
      return t === 'ELIZNA™ Home' || t === 'Shop ELIZNA™';
    });

    if (!exploreLink) return;

    const list = exploreLink.closest('ul') || exploreLink.parentElement?.parentElement;
    if (!list) return;

    const li = document.createElement('li');
    li.className = 'elizna-footer-pro-v2__app-item';

    const a = document.createElement('a');
    a.href = '/pages/elizna-app';
    a.className = 'elizna-footer-pro-v2__app-link';
    a.textContent = 'The ELIZNA™ App';

    li.appendChild(a);

    const shopLink = [...list.querySelectorAll('a')].find((el) => normalize(el.textContent) === 'Shop ELIZNA™');

    if (shopLink?.parentElement) {
      shopLink.parentElement.insertAdjacentElement('afterend', li);
    } else {
      list.appendChild(li);
    }
  };

  const polishNewsletter = (footer) => {
    const email = footer.querySelector('input[type="email"]');
    if (email) {
      email.setAttribute('placeholder', 'Your email address');

      const id = email.id;
      if (id) {
        const label = footer.querySelector(`label[for="${CSS.escape(id)}"]`);
        if (label && normalize(label.textContent).toLowerCase() === 'email') {
          label.textContent = 'Your email address';
        }
      }
    }
  };

  const init = () => {
    const footer = findFooter();
    if (!footer) return;

    footer.classList.add('elizna-footer-pro-v2');

    relabel(footer);
    addAppLink(footer);
    polishNewsletter(footer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
